import { render, staticRenderFns } from "./historyMsg.vue?vue&type=template&id=6617d84c&"
import script from "./historyMsg.vue?vue&type=script&lang=js&"
export * from "./historyMsg.vue?vue&type=script&lang=js&"
import style0 from "./historyMsg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports